//roadmap
import * as THREE from 'three';
import Tween from 'root/animator/tween/tween'
import Ease from 'root/animator/tween/easing'
import { dispatchSetChanging } from '../utils'
import { layers } from '../constants';

class Object6 {
    instance = new THREE.Group()
    geometry
    material

    shader

    group
    gPosition = {
        
    }

    state = {
        changing: false,
        visible: false,
        move: 0
    }

    position = [ 0, -0.3, 0 ]
    rotation = [ 0, 0, 0 ]

    parallelData = {
        visible: {
            positions: []
        },
        hidden: {
            positions: []
        }
    }

    I = 100
    J = 100

    name = "Terrain"

    constructor(scene) {
        this.init( scene )
    }

    init(scene) {
        this.shader = {
            uniforms: {
              iAnimation: { value: 0 }, //0 -> 1 -> 2
              iTime: { value: 0 },
              iResolution: { value: {
                x: window.innerWidth * window.devicePixelRatio,
                y: window.innerHeight * window.devicePixelRatio
              }},
              uAlpha: { value: 0 }
            },
            vertexShader: `
              uniform float iAnimation;
              uniform float iTime;
              uniform vec2 iResolution;
              
              varying float cameraDistance;
              varying float z;
              varying vec3 c;
              vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
              vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}
              vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}
              float cnoise(vec3 P){
                vec3 Pi0 = floor(P); // Integer part for indexing
                vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
                Pi0 = mod(Pi0, 289.0);
                Pi1 = mod(Pi1, 289.0);
                vec3 Pf0 = fract(P); // Fractional part for interpolation
                vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
                vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
                vec4 iy = vec4(Pi0.yy, Pi1.yy);
                vec4 iz0 = Pi0.zzzz;
                vec4 iz1 = Pi1.zzzz;
                vec4 ixy = permute(permute(ix) + iy);
                vec4 ixy0 = permute(ixy + iz0);
                vec4 ixy1 = permute(ixy + iz1);
                vec4 gx0 = ixy0 / 7.0;
                vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
                gx0 = fract(gx0);
                vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
                vec4 sz0 = step(gz0, vec4(0.0));
                gx0 -= sz0 * (step(0.0, gx0) - 0.5);
                gy0 -= sz0 * (step(0.0, gy0) - 0.5);
                vec4 gx1 = ixy1 / 7.0;
                vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
                gx1 = fract(gx1);
                vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
                vec4 sz1 = step(gz1, vec4(0.0));
                gx1 -= sz1 * (step(0.0, gx1) - 0.5);
                gy1 -= sz1 * (step(0.0, gy1) - 0.5);
                vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
                vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
                vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
                vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
                vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
                vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
                vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
                vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
                vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
                g000 *= norm0.x;
                g010 *= norm0.y;
                g100 *= norm0.z;
                g110 *= norm0.w;
                vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
                g001 *= norm1.x;
                g011 *= norm1.y;
                g101 *= norm1.z;
                g111 *= norm1.w;
                float n000 = dot(g000, Pf0);
                float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
                float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
                float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
                float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
                float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
                float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
                float n111 = dot(g111, Pf1);
                vec3 fade_xyz = fade(Pf0);
                vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
                vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
                float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
                return 2.2 * n_xyz;
              }
              const mat2 m2 = mat2(0.8,-0.6,0.6,0.8);
              float fbm( in vec3 p ){
                float f = 0.0;
                f += 0.55000 * cnoise(p);
                p.xz = m2 * p.xz * 2.02;
                f += 0.050 * cnoise(p);
                p.xz = m2 * p.xz * 2.05;
                f += 0.350 * cnoise(p);
                return f;
              }
              vec2 wnoise(vec2 pos, float t, float curv) {
                pos.x += curv * sin(2.0*t+1.5 * pos.y)+t*0.5;
                pos.y += curv * cos(2.0*t+1.5 * pos.x);
                return 0.5 + 0.5*cos(pos.xy+vec2(0,2));
              }
              vec3 hsv2rgb(vec3 c) {
                vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
                vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
                return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
              }
              void main() {
                vec3 v = position;
                float anim1 = clamp(iAnimation, 0., 1.);
                float anim2 = clamp(iAnimation-1., 0., 1.);
                v.z = fract(v.z + anim1);
                v.x = fract(v.x + anim2);
                v.x = 4. * (v.x * 1.6 - 0.8);
                v.z = 4. * (v.z * 1.3 - 0.65);
                v.y = .65 * (clamp(abs((v.x)/2. + 2. - 2.4 * anim2), 0., 1.))
                          * fbm(.5 * (v - vec3(.6 * iTime + 6.4 * anim2, 0., 5.2 * anim1))) - .2 * v.x;
                v.x -= .3 * v.z - .3;
                vec2 h = wnoise(8.*(position.xy - vec2(iTime/10.6, 0.)), 0., .4);
                float hue = (h.x+h.y)/2.;
                float fade = cnoise(5.*(vec3(position.xz, 0.) - vec3(iTime/10.6, 0., 0.))) * 1.3 + 0.7;
                c = hsv2rgb(vec3(.4 + .12 * hue, 1., 1.)) * fade;
                vec4 mvpos = modelViewMatrix * vec4(v, 1.);
                z = v.z;
                cameraDistance = length(cameraPosition - v);
                gl_PointSize = 17.5 * iResolution.y / 730. / -mvpos.z;
                gl_Position = projectionMatrix * mvpos;
              }`,
            fragmentShader: `
              varying float cameraDistance;
              varying float z;
              varying vec3 c;
              uniform float uAlpha;
              void main() {
                float d0 = .3;
                float d = max(0., length(2. * gl_PointCoord - 1.) - d0) * max(.3, 1.5 * cameraDistance) * 8.;
                float tex = pow(2.71828, -d*d / 2.) / 2.506628; // gauss blur
                gl_FragColor = vec4(tex * c * 1.8, tex * min(1., (-z+2.7)/1.3) * (z+2.7)/1.3) * uAlpha;
              }`
          }
        // starsPass.uniforms.iResolution = terrainShader.uniforms.iResolution;
        this.geometry = new THREE.BufferGeometry();
        const positions = []
        const sizes = []
        for ( let i = 0; i < this.I; i++ ) {
            for (let j = 0; j < this.J; j++) {
                const x = i / this.I * 1.8 - 0.9;
                const y = Math.random();
                const z = j / this.J * 1.7 - 0.85;

                const hiddenX = x
                const hiddenY = y
                const hiddenZ = 0

                positions.push( hiddenX, hiddenY, hiddenZ );
                this.parallelData.visible.positions.push({ x, y, z })
                this.parallelData.hidden.positions.push({ x: hiddenX, y: hiddenY, z: hiddenZ })
            }
        }
        this.geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( positions, 3 ) )
        this.geometry.setAttribute( 'size', new THREE.Float32BufferAttribute( sizes, 1 ) )

        this.material = new THREE.ShaderMaterial( {
            vertexShader: this.shader.vertexShader,
            fragmentShader: this.shader.fragmentShader,
            uniforms: this.shader.uniforms,
            defines: Object.assign( {}, this.shader.defines ),
            depthTest: false,
            transparent: true
        })
        this.material.stencil = false

        this.group = new THREE.Points(this.geometry, this.material)

        this.instance.add( this.group ) 
        this.instance.name = this.name
        this.group.layers.enable(layers.BLOOM_SCENE)

        this.instance.position.set(...this.position)
        this.instance.rotation.set(...this.rotation)

        scene.add(this.instance)
        this.instance.visible = false
    }

    rMinMax(min: number, max: number) {
        return Math.random() * ( max - min ) + min
    }

    resize() {
        // starsPass.uniforms[ 'iResolution' ].value.x = window.innerWidth * window.devicePixelRatio
        // starsPass.uniforms[ 'iResolution' ].value.y = window.innerHeight * window.devicePixelRatio
    }

    render__moveIn() {
        this.render__move(
            {
                array: this.parallelData.hidden.positions,
                alpha: 0
            },
            {
                array: this.parallelData.visible.positions,
                alpha: 1
            },
            () => { this.state.visible = true },
            Ease.Out 
        )
    }
    render__moveOut() {
        this.render__move(
            {
                array: this.parallelData.visible.positions,
                alpha: 1
            },
            {
                array: this.parallelData.hidden.positions,
                alpha: 0
            },
            () => { this.state.visible = false },
            Ease.In,
            0,
            1000
        )
    }
    render__move(from: any, to: any,  onComplete = () => {}, ease = Ease.InCubic, delay = 1000, duration = 2000) {
        this.state.changing = true
        dispatchSetChanging(true, 0)
        Tween.to(from, to,
            {
                renderDelay: 10,
                delay,
                duration,
                ease: ease,
                onChange: function(context) {
                    for (let i = 0; i < this.I * this.J; i++) {
                        this.geometry.attributes.position.setXYZ(i, context.value.array[i].x, context.value.array[i].y, context.value.array[i].z)
                    }
                    this.shader.uniforms.uAlpha.value = context.value.alpha
                    this.geometry.attributes.position.needsUpdate = true
                }.bind(this),
                onComplete: function() { 
                    this.state.changing = false 
                    dispatchSetChanging(false)
                    onComplete()
                }.bind(this)
            }
        )
    }
    render__innermove(from: any, to: any, delay = 0, duration = 1500) {
        this.state.changing = true
        dispatchSetChanging(true, 0)
        Tween.to(from, to,
            {
                renderDelay: 10,
                delay,
                duration,
                ease: Ease.InOutCubic,
                onChange: function(context) {
                    this.shader.uniforms.iAnimation.value = context.value
                }.bind(this),
                onComplete: function() { 
                    this.state.changing = false 
                    dispatchSetChanging(false)
                }.bind(this)
            }
        )
    }



    render({ visible = false, move = null }) {
        if ( !this.state.changing ) {
            if ( !visible && this.state.visible ) {
                this.render__moveOut()
            } else
            if ( visible && !this.state.visible ) {
                this.render__moveIn()
            }
        }

        if (this.state.visible || visible) {
            let t = performance.now() / 1000;
            this.shader.uniforms[ 'iTime' ].value = t;
            this.instance.visible = true
        } else {
            this.instance.visible = false
        }

        if (move !== null) {
            if (move !== this.state.move) {
                const m = this.state.move
                this.render__innermove(m, move)
                this.state.move = move
            }
        }



        // cornerPass.uniforms[ 'iTime' ].value = t;
        // starsPass.update(t);
        //terrainPass.update(t);
        // terrainPass.uniforms.iTime.value = t;
    }
}

export default Object6